import badge1 from "@images/badges/badge-1.png";
import badge2 from "@images/badges/badge-2.png";
import badge3 from "@images/badges/badge-3.png";
import badge4 from "@images/badges/badge-4.png";
import badge5 from "@images/badges/badge-5.png";
import badge6 from "@images/badges/badge-6.png";
import badge7 from "@images/badges/badge-7.png";
import badge8 from "@images/badges/badge-8.png";
import badge9 from "@images/badges/badge-9.png";
import badge10 from "@images/badges/badge-10.png";

export const SCENARIO_CERTIFICATION_BADGES = [
  {
    id: 0,
    image: badge1,
    name: "badge_1",
  },
  {
    id: 1,
    image: badge2,
    name: "badge_2",
  },
  {
    id: 2,
    image: badge3,
    name: "badge_3",
  },
  {
    id: 3,
    image: badge4,
    name: "badge_4",
  },
  {
    id: 4,
    image: badge5,
    name: "badge_5",
  },
  {
    id: 5,
    image: badge6,
    name: "badge_6",
  },
  {
    id: 6,
    image: badge7,
    name: "badge_7",
  },
  {
    id: 7,
    image: badge8,
    name: "badge_8",
  },
  {
    id: 8,
    image: badge9,
    name: "badge_9",
  },
  {
    id: 9,
    image: badge10,
    name: "badge_10",
  },
];

export const SCENARIO_DEFAULT_CRITERIA = {
  visit_opening: {
    company_standard_greetings: 0,
    small_talk: 0,
    purpose_said: 0,
    got_approve_to_visit: 0,
    used_relationship_history: 0,
  },
  doctor_segmentation: {
    check_loyalty_to_brand: 0,
    check_patient_statistics: 0,
  },
  needs_identification: {
    check_therapeutic_preferences: 0,
    active_listening: 0,
    check_previous_visit_results: 0,
    check_reasons_for_drug_choice: 0,
  },
  presentation: {
    key_messages: 0,
    keywords: 0,
    presentation_according_to_criteria: 0,
    relevant_argumentation: 0,
    control_questions: 0,
    FAB_technique: 0,
  },
  objection_handling: {
    clarify_objection: 0,
    four_stages_objection_handling: 0,
    competitor_differentiation: 0,
    check_agreement: 0,
  },
  visit_closing: {
    quantitative_agreements: 0,
    visit_summary: 0,
    patient_portrait_clarification: 0,
    closing_control_questions: 0,
    doctor_pharmacy_link: 0,
  },
  visit_structure: {
    structure_adherence: 0,
  },
  dialogue_balance: {
    talk_time_distribution: 0,
    doctor_engagement: 0,
    dominance_check: 0,
  },
  engagement: {
    emotional_engagement: 0,
    questions_quality: 0,
  },
  factual_base: {
    evidence_quality: 0,
    research_usage: 0,
    kols_references: 0,
  },
};

export const SCENARIO_MAYOLY_CRITERIA = {
  visit_opening: {
    company_standard_greetings: 0,
    small_talk: 0,
    purpose_said: 0,
    got_approve_to_visit: 0,
    used_relationship_history: 0,
  },
  doctor_segmentation: {
    check_loyalty_to_brand: 0,
    check_patient_statistics: 0,
  },
  needs_identification: {
    check_therapeutic_preferences: 0,
    active_listening: 0,
    check_previous_visit_results: 0,
    check_reasons_for_drug_choice: 0,
    problem_actualization: 0,
  },
  presentation: {
    key_messages: 0,
    keywords: 0,
    presentation_according_to_criteria: 0,
    relevant_argumentation: 0,
    control_questions: 0,
    FAB_technique: 0,
    recommendation_algorithm: 0,
  },
  objection_handling: {
    clarify_objection: 0,
    four_stages_objection_handling: 0,
    competitor_differentiation: 0,
    check_agreement: 0,
  },
  visit_closing: {
    quantitative_agreements: 0,
    visit_summary: 0,
    patient_portrait_clarification: 0,
    closing_control_questions: 0,
    doctor_pharmacy_link: 0,
  },
  visit_structure: {
    structure_adherence: 0,
  },
  dialogue_balance: {
    talk_time_distribution: 0,
    doctor_engagement: 0,
    dominance_check: 0,
    drug_time_distribution: 0,
  },
  engagement: {
    emotional_engagement: 0,
    questions_quality: 0,
  },
  factual_base: {
    evidence_quality: 0,
    research_usage: 0,
    kols_references: 0,
  },
};

export const getScenarioCriteria = (isMayoly) =>
  isMayoly ? SCENARIO_MAYOLY_CRITERIA : SCENARIO_DEFAULT_CRITERIA;

export const API_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
